<template>
  <div class="content">
    <div class="row animated fadeIn">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header">
            <h4 class="card-title pull-left">
              Firebase Backups
            </h4>
          </div>
          <div class="card-body">
            <div class="loader small_loader" v-if="loading"></div>
            <table class="table table-striped table-bordered">
              <thead>
              <tr>
                <th>Backup</th>
                <th class="text-center">Status</th>
                <th class="text-center">Created At</th>
                <th class="text-center">Completed At</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="row in allBackups" :key="row.id">
                <td>
                  {{ row.fileName }}
                </td>
                <td class="text-center">
                  <span v-if="row.status === 'pending'">
                     <i class="fa fa-spinner fa-spin text-primary" style="font-size:24px"></i>
                  </span>
                  <span v-else-if="row.status === 'completed'">
                    <i class="fa fa-check-circle text-success fs-24" style="font-size:24px"></i>
                  </span><span v-else-if="row.status === 'failed'">
                    <i class="fa fa-times-circle text-danger fs-24" style="font-size:24px"></i>
                  </span>
                </td>
                <td width="15%" class="text-center">
                  {{row.createdAt | formatDate}}
                </td>
                <td width="15%" class="text-center">
                  <span v-if="row.completedAt">{{row.completedAt | formatDate}}</span>
                </td>
              </tr>
              <template v-if="!loading && allBackups.length === 0">
                <tr>
                  <td class="col-md-10 text-center text-danger mb-3 font-weight-bold" colspan="4">No Data Exists!</td>
                </tr>
              </template>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {db} from "@/firebase/init";
export default {
  name: "firebaseBackups",
  data() {
    return {
      loading: false,
      allBackups: []
    }
  },
  mounted() {
    this.getFirebaseBackups()
  },
  methods: {
    async getFirebaseBackups() {
      try {
        this.loading = true;
        this.allBackups = [];
        const ref = await db.collection('firebaseBackups').orderBy('createdAt', 'desc').get();
        if (ref.size) {
          ref.forEach(el => {
            this.allBackups.push({id: el.id, ...el.data()});
          })
        }
        console.log('all backups', this.allBackups)
      } catch (e) {
        console.log('error from getting backups', e.toString());
      } finally {
        this.loading = false;
      }
    }
  }
}
</script>

<style scoped>

</style>
